import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from 'rc-pagination';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
// Locale
import messages from '../../locale/jsonMessages';
import { flowRight as compose } from 'lodash';
import s from 'rc-pagination/assets/index.css';
import t from '../../styles/customPagination.css';

class CustomPagination extends Component {

    static propTypes = {
        total: PropTypes.number.isRequired,
        defaultCurrent: PropTypes.number.isRequired,
        defaultPageSize: PropTypes.number.isRequired,
        change: PropTypes.any.isRequired,
        currentPage: PropTypes.number.isRequired,
        paginationLabel: PropTypes.string
    };

    static defaultProps = {
        paginationLabel: 'items'
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.renderShowTotal = this.renderShowTotal.bind(this);
    }

    handleChange(currentPage, size) {
        const { change } = this.props;
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        change(currentPage);
    }

    renderShowTotal(total, range) {
        const { paginationLabel } = this.props;

        return (
            <div className={s.resultsCount}>
                <span>{range[0]}</span>
                <span>&nbsp;–&nbsp;</span>
                <span>{range[1]}</span>
                <span className='displayInlineRTL'>&nbsp;<FormattedMessage {...messages.of} />&nbsp;</span>
                <span>{total}</span>
                <span>&nbsp;{paginationLabel}</span>
            </div>
        );
    }

    render() {
        const { total, defaultCurrent, defaultPageSize, currentPage } = this.props;
        const locale = { prev_page: 'Previous', next_page: 'Next' };
        return (
            <div className={"customPaginationContainer"}>
                <Pagination
                    defaultCurrent={defaultCurrent}
                    current={currentPage}
                    total={total}
                    defaultPageSize={defaultPageSize}
                    onChange={this.handleChange}
                    showTotal={(total, range) => this.renderShowTotal(total, range)}
                    locale={locale}
                    showLessItems
                    prevIcon={<span className='rc-pagination-navigation-icon' />}
                    nextIcon={<span className='rc-pagination-navigation-icon' />}
                    jumpPrevIcon={
                        <span className='rc-pagination-jump-custom-icon'>
                            <span className='rc-pagination-jump-beforeHover-icon'>&#8226;&#8226;&#8226;</span>
                            <span className='rc-pagination-jump-afterHover-icon'>&#8249;&#8249;</span>
                        </span>
                    }
                    jumpNextIcon={
                        <span className='rc-pagination-jump-custom-icon'>
                            <span className='rc-pagination-jump-beforeHover-icon'>&#8226;&#8226;&#8226;</span>
                            <span className='rc-pagination-jump-afterHover-icon'>&#8250;&#8250;</span>
                        </span>
                    }
                    align={"center"}
                />
            </div>
        );
    }


}
export default compose(withStyles(s, t), injectIntl)(CustomPagination);
